/* Dropdown component that relies on react-select and its CSS */
import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select'; //eslint-disable-line
import { Creatable } from 'react-select'; //eslint-disable-line
import 'react-select/dist/react-select.css';

const option = (value, label, render, disabled = false) => (
  { value, label, render, disabled }
);

const group = options => (
  (options.reduce((acc, o) => {
    const { value, label, className, children } = o;
    const parentOption = option(value, label, <div className={className}>{ label }</div>, true);
    const childrenOptions = children.map((c) => {
      const classList = c.className ? `Select-optgroup-children ${c.className}` : 'Select-optgroup-children';
      return option(c.value, c.label, <div className={classList}>{ c.label }</div>);
    });
    return acc.concat(parentOption).concat(childrenOptions);
  }, []))
);

// Transforms option {value:'v', label:'l', children: [{value:'',label:'':},{value:'',label:''},...]}
// into something equivalent to an <optgroup> HTML tag.
const transformOptions = (props) => {
  const { optGroup, options } = props;

  if (!options) {
    return;
  }

  if (!optGroup) {
    return options;
  }

  return group(options);
};

export default function Dropdown(props) {
  const {
    selectedValue,
    onSelect,
    multi,
    name,
    creatable,
    clearable,
    searchable,
    className,
    optionClassName,
    optGroup,
    placeholder,
    isLoading,
    disabled
  } = props;

  const defaultProps = {
    name,
    value: selectedValue,
    options: transformOptions(props),
    onChange: onSelect,
    multi,
    clearable,
    searchable,
    className,
    optionClassName,
    optGroup,
    placeholder,
    isLoading,
    disabled
  };

  if (optGroup) {
    defaultProps.optionRenderer = opt => opt.render;
  }

  if (creatable) {
    return <Creatable {...defaultProps} />;
  }

  return <Select {...defaultProps} />;
}

Dropdown.propTypes = {
  /** name used for hidden <input /> tag */
  name: PropTypes.string,
  /** currently selected value, can be null */
  selectedValue: PropTypes.any, // eslint-disable-line
  /** specifies whether selections can be cleared */
  clearable: PropTypes.bool,
  /** specifies whether new options can be created */
  creatable: PropTypes.bool,
  /** specifies whether the options are searchable */
  searchable: PropTypes.bool,
  /** specifies whether multiple selections can be made */
  multi: PropTypes.bool,
  /** array of the options to be selected from */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any,
      label: PropTypes.string,
      className: PropTypes.string
    })
  ),
  /** callback for when an option is selected. Arg will be entire option
    * object
    */
  onSelect: PropTypes.func,
  /** placed on the options themselves */
  optionClassName: PropTypes.string,
  /** placed on the outer element */
  className: PropTypes.string,
  /** format the options like an html select optgroup */
  optGroup: PropTypes.bool,
  /** default placeholder text is "Select..." */
  placeholder: PropTypes.string,
  /** default isLoading is false */
  isLoading: PropTypes.bool,
  /** default disabled is false */
  disabled: PropTypes.bool
};

Dropdown.defaultProps = {
  clearable: true,
  // TODO(meag): creatable seems to have been broken for some time. I tried, no avail.
  creatable: false,
  searchable: false,
  multi: false,
  optGroup: false,
  isLoading: false,
  disabled: false
};



// WEBPACK FOOTER //
// ./node_modules/@localytics/loc-components/lib/Dropdown.jsx